import type { IHttpClient } from '@wix/http-client'
import { type EnterpriseInfo } from '@wix/ambassador-enterprise-v1-enterprise-info/types'
import { getEnterpriseInfo as getEnterpriseInfoRequest } from '@wix/ambassador-enterprise-v1-enterprise-info/http'

export type { EnterpriseInfo } from '@wix/ambassador-enterprise-v1-enterprise-info/types'

export const getEnterpriseInfo = (
  httpClient: IHttpClient,
): Promise<EnterpriseInfo | undefined> =>
  httpClient
    .request(getEnterpriseInfoRequest({}))
    .then(response => response.data.enterpriseInfo)
